"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("./internal");
class BurstTime {
    constructor(burstTimestamp) {
        this._burstTimestamp = burstTimestamp;
    }
    static fromBurstTimestamp(burstTimestamp) {
        return new BurstTime(burstTimestamp);
    }
    static fromDate(date) {
        const burstTime = new BurstTime(0);
        burstTime.setDate(date);
        return burstTime;
    }
    getBurstTimestamp() {
        return this._burstTimestamp;
    }
    setBurstTimestamp(burstTimestamp) {
        this._burstTimestamp = burstTimestamp;
    }
    getEpoch() {
        return (internal_1.GenesisBlockTime + this._burstTimestamp) * 1000;
    }
    getDate() {
        return new Date(this.getEpoch());
    }
    setDate(date) {
        this._burstTimestamp = Math.round(date.getTime() / 1000) - internal_1.GenesisBlockTime;
    }
    equals(burstTime) {
        return this._burstTimestamp === burstTime._burstTimestamp;
    }
    before(burstTime) {
        return this._burstTimestamp < burstTime._burstTimestamp;
    }
    after(burstTime) {
        return this._burstTimestamp > burstTime._burstTimestamp;
    }
}
exports.BurstTime = BurstTime;
//# sourceMappingURL=burstTime.js.map